import { SiteConfig } from '../types/portfolio';

export const siteConfig: SiteConfig = {
  name: 'Sushil Kumar',
  initials: 'SK',
  title: 'Senior Java Full Stack Engineer',
  location: 'Bangalore, India',
  experienceLabel: '6+ Years Building Enterprise Software Systems',
  tagline:
    'Designing scalable backend systems, microservices platforms, and modern web applications using Java and React.',
  summary: [
    'A passionate Java Full Stack Engineer with over 6 years of experience developing enterprise-grade applications using Java, Spring Boot, and Microservices architecture.',
    'Experienced in building scalable backend services, RESTful APIs, and modern web interfaces using ReactJS. Skilled in working with Agile teams and delivering high quality production-ready solutions.',
  ],
  email: '94sushilkr@gmail.com',
  phone: '9738728096',
  linkedinUrl: 'https://www.linkedin.com/in/sushil-kumar-3136a9145/',
  githubUrl: process.env.REACT_APP_GITHUB_URL || '',
  githubDisplayText: process.env.REACT_APP_GITHUB_URL || 'GitHub profile link can be added anytime',
  metaTitle: 'Sushil Kumar | Senior Java Full Stack Engineer',
  metaDescription:
    'Premium portfolio for Sushil Kumar, a Senior Java Full Stack Engineer specializing in Spring Boot, Microservices, ReactJS, REST APIs, and enterprise-scale application delivery.',
  siteUrl: process.env.REACT_APP_SITE_URL || 'https://your-portfolio-domain.com',
  keywords: [
    'Sushil Kumar',
    'Senior Java Full Stack Engineer',
    'Java',
    'Spring Boot',
    'Microservices',
    'ReactJS',
    'REST APIs',
    'Enterprise Software Development',
  ],
  stats: [
    { value: '6+ Years', label: 'Enterprise software delivery' },
    { value: 'Java + React', label: 'Full-stack engineering focus' },
    { value: 'Spring Boot', label: 'Scalable microservices delivery' },
  ],
  aboutHighlights: [
    'Enterprise-grade backend systems',
    'Scalable REST API design',
    'Microservices architecture',
    'Agile cross-functional delivery',
  ],
  navItems: [
    { label: 'About', href: '#about' },
    { label: 'Experience', href: '#experience' },
    { label: 'Projects', href: '#projects' },
    { label: 'Skills', href: '#skills' },
    { label: 'Tech Stack', href: '#tech-stack' },
    { label: 'GitHub', href: '#github' },
    { label: 'Contact', href: '#contact' },
  ],
  skills: [
    {
      title: 'Backend Engineering',
      description: 'Enterprise Java delivery focused on reliability, modularity, and maintainable service design.',
      skills: ['Java', 'Spring', 'Spring Boot', 'Spring MVC', 'Spring Data JPA', 'Hibernate', 'Microservices'],
    },
    {
      title: 'Frontend Engineering',
      description: 'Responsive product interfaces for internal business users and enterprise workflows.',
      skills: ['ReactJS', 'JavaScript', 'HTML5', 'CSS3', 'JSP', 'Thymeleaf'],
    },
    {
      title: 'DevOps & Platform',
      description: 'Delivery tooling and runtime environments used across production-grade teams.',
      skills: ['Docker', 'Kubernetes', 'Jenkins', 'Maven', 'Gradle', 'Tomcat', 'JBoss', 'Jetty'],
    },
    {
      title: 'Databases & Delivery',
      description: 'Strong collaboration across data, tooling, and delivery practices in Agile programs.',
      skills: ['MySQL', 'MongoDB', 'Git', 'JIRA', 'IntelliJ', 'Eclipse', 'Agile', 'Scrum'],
    },
  ],
  techStack: [
    {
      category: 'Backend',
      items: ['Java', 'Spring Boot', 'Spring MVC', 'Spring Data JPA', 'Hibernate', 'Microservices'],
    },
    {
      category: 'Frontend',
      items: ['ReactJS', 'JavaScript', 'HTML5', 'CSS3', 'JSP', 'Thymeleaf'],
    },
    {
      category: 'Database',
      items: ['MySQL', 'MongoDB'],
    },
    {
      category: 'DevOps',
      items: ['Docker', 'Kubernetes', 'Jenkins', 'Maven', 'Gradle'],
    },
  ],
  experience: [
    {
      company: 'Wipro Technologies',
      role: 'Senior Project Engineer',
      duration: '2022 - Present',
      responsibilities: [
        'End-to-end implementation of enterprise projects including requirement analysis, system design, development, and testing.',
        'Followed Agile Scrum methodology across delivery sprints and stakeholder collaboration.',
        'Participated in code reviews and maintained code quality across the application lifecycle.',
        'Used Git for version control and Jira for defect tracking and work management.',
      ],
      stack: ['Java', 'Spring Boot', 'ReactJS', 'Git', 'JIRA', 'Agile Scrum'],
    },
  ],
  projects: [
    {
      title: 'United Health Group Platform',
      description:
        'Worked on enterprise healthcare system development including requirement gathering, backend services, and API integration.',
      technologies: ['Java', 'Spring Boot', 'Microservices', 'React', 'REST APIs'],
    },
    {
      title: 'Edward Jones Legal Discovery Platform',
      description:
        'Developed a web-based interface using ReactJS for submitting legal trade confirmation requests.',
      features: [
        'Dynamic form submission',
        'Date range filtering',
        'Document retrieval system',
        'File storage management',
        'Email notification system',
      ],
      architecture: 'Microservices based backend system',
      technologies: ['ReactJS', 'Spring Boot', 'REST APIs', 'Microservices'],
    },
  ],
  education: {
    degree: 'B.E Electronics and Communication Engineering',
    college: 'Sri Krishna Institute of Technology',
    location: 'Bangalore, India',
  },
  contactMethods: [
    { label: 'Email', value: '94sushilkr@gmail.com', href: 'mailto:94sushilkr@gmail.com' },
    { label: 'Phone', value: '9738728096', href: 'tel:+919738728096' },
    { label: 'Location', value: 'Bangalore, India' },
    {
      label: 'LinkedIn',
      value: 'linkedin.com/in/sushil-kumar-3136a9145',
      href: 'https://www.linkedin.com/in/sushil-kumar-3136a9145/',
    },
  ],
};
